const SARCData = [
    {
        state: 'Andaman and Nicobar Islands (UT)',
        sarcCenters: [
            {
                name: 'One Stop Center, Nicobars',
                address: 'One Stop Centre, Perka, Headquarters, Car Nicobar, Nicobars- 744301',
                phone: '03193-265121'
            },
            {
                name: 'One Stop Center, North & Middle Andaman',
                address: 'One Stop Centre, Old DRDA Office, O/o. The Deputy Commissioner, Near State Library, Mayabunder, North & Middle Andaman-744204',
                phone: '03192-273009'
            },
            {
                name: 'One Stop Center, South Andaman',
                address: 'One Stop Centre, JG 6-Type, V Quarter, Near Ayush, (Govt.) Hospital, Junglighat, Port Blair, South Andaman District, Andaman & Nicobar Islands',
                phone: '0319-2230504'
            },
        ]
    },



    {
        state: 'Andhra Pradesh',
        sarcCenters: [
            {
                name: 'One Stop Center, Krishna',
                address: 'One Stop Centre, Shaik Raja Sahib Municipal Maternity Hospital, Kothapet, Vijaywada City, Krishna District, Andhra Pradesh',
                phone: '9398914772, 9949397133, 9440280053, 9398914772'
            },
            {
                name: 'One Stop Center, Chittoor',
                address: 'One Stop Centre, RIMSGeneral Hospital, Municipal Maternity Ward, Chittoor City, Chittoor District, Andhra Pradesh',
                phone: '9959776697, 8897600654, 9951909222'
            },
            {
                name: 'One Stop Center, Srikakulam',
                address: 'One Stop Centre, RIMSGeneral Hospital, Balaga, Srikakulam City, Srikakulam District, Andhra Pradesh532001 ',
                phone: '9110793708, 7386965008, 7997879976,'
            },
        ]
    },



    {
        state: 'Arunachal Pradesh',
        sarcCenters: [
            {
                name: 'One Stop Center, Papumpare',
                address: 'One Stop Centre, Tomo Riba Institute of Health and Medical Science (TRIHMS) Papumpare District, Arunachal Pradesh ',
                phone: '7085086296'
            },
            {
                name: 'One Stop Center, East Siang',
                address: 'One Stop Centre, High Region, Near General Hospital, Pasighat, East Siang District, Arunachal Pradesh ',
                phone: '8915900550'
            },
            {
                name: 'One Stop Center, Tawang',
                address: 'One Stop Centre, DFDO Quarter, Craft Centre Colony, Near District Hospital, Tawang-790104',
                phone: '9862110421'
            },
        ]
    },



    {
        state: 'Goa',
        sarcCenters: [
            {
                name: 'One Stop Center, North Goa',
                address: 'One Stop Centre, Goa Medical College, NH-17, Bambolim, Tiswadi, North Goa District, Goa-403202',
                phone: '0832-2458700'
            },
            {
                name: 'One Stop Center, South Goa',
                address: 'One Stop Centre, Junta Quarters, Pajifond Margao, Salcete, South Goa',
                phone: '9423884669,9767143928'
            },
        ]
    },



    {
        state: 'Haryana',
        sarcCenters: [
            {
                name: 'One Stop Center, Ambala',
                address: '#39 A, Ganesh Vihar, NasirpurDurga Nagar, Ambala',
                phone: '0171-2530910'
            },
            {
                name: 'One Stop Center, Bhiwani',
                address: 'One Stop Centre, Old SDM Residence, Near Civil Hospital Ghanta Ghar Chowk',
                phone: '01664-240044, 7015932690'
            },
            {
                name: 'One Stop Center, Faridabad',
                address: 'One Stop Centre, Kasturba Seva Sadan, Near SBI Bank, Neelam Chowk, Faridabad',
                phone: '0129-2265199, 9999367552 9033758060'
            },
        ]
    },



    {
        state: 'Himachal Pradesh',
        sarcCenters: [
            {
                name: 'One Stop Center, Bilaspur',
                address: 'One Stop Centre, Working Women Hostel,Near Kalyan Bhawan Shaheed Smark,Bilaspur-174011',
                phone: '01978-221514'
            },
            {
                name: 'One Stop Center, Chamba',
                address: 'One Stop Centre, Village Sarol,Near leprosy Rehabilitation Centre, PO Sarol, District Chamba176310',
                phone: '1899220307'
            },
            {
                name: 'One Stop Center, Hamirpur',
                address: 'One Stop Centre, DCPO Office, Nadaun Chowk, Hamirpur-174011',
                phone: '1972225085'
            },
        ]
    },



    {
        state: 'Jammu & Kashmir',
        sarcCenters: [
            {
                name: 'One Stop Center, Rajouri',
                address: 'One Stop Centre, ITI Road, near Animal Husbandry Building, Jammu and Kashmir-185151',
                phone: '01962260140, 9596731557'
            },
            {
                name: 'One Stop Center, Srinagar',
                address: 'Sakhi Centre Srinagar,,Opposite New Era School, Rajbagh, Srinagar190008',
                phone: '7889622272'
            },
            {
                name: 'One Stop Center, Anantnag',
                address: 'Nai Basti General Bus stand Anantnag,-192101',
                phone: '9469444334'
            },
        ]
    },



    {
        state: 'Ladakh',
        sarcCenters: [
            {
                name: 'One Stop Center, Leh',
                address: 'Assistant Labour Commissioner office Skampari Leh Ladakh-194101',
                phone: '7051382522'
            },
        ]
    },



    {
        state: 'Jharkhand',
        sarcCenters: [
            {
                name: 'One Stop Center, Ranchi',
                address: 'One Stop Centre, Ranchi Institute of Neuro-Psychiatry and Allied Sciences (RINPAS), Kanke District, Ranchi , Jharkhand-834006',
                phone: '0651-2451911, 9931523455'
            },
            {
                name: 'One Stop Center, East Singhbhum',
                address: 'One Stop Centre, Red Cross Bhavan 3rd floor –Sakhi,Near ubilee Park Gate, Jamshedpur, East Singhbhum District, Jharkhand-831001',
                phone: '7209407209, 7209407209'
            },
            {
                name: 'One Stop Center, Dhanbad',
                address: 'One Stop Centre, One Stop Centre, Red Cross Bhavan, Behind Golf Ground Dhanbad, Dhanbad District, Jharkhand-831001',
                phone: '9334261037'
            },
        ]
    },



    {
        state: 'Karnataka',
        sarcCenters: [
            {
                name: 'One Stop Center, Udupi',
                address: 'One Stop Centre, StreeSevaniketana District Hospital premises, Udupi, Udupi District, Karnataka',
                phone: '080-22353992'
            },
            {
                name: 'One Stop Center, Dharwad',
                address: 'One Stop Center, District Hospital, Special Treatment Unit, KIMS Hospital Hubli, Dharwad, Karnataka -580020',
                phone: '8362270020'
            },
            {
                name: 'One Stop Center, Chamarajnagar',
                address: 'One Stop Centre, Special Treatment Unit, District Hospital 2nd Floor B.Rachaiah Jodi, Rd. Chamaraja Nagara, ChamarajaNagara District, Karnataka-571313',
                phone: '08226-224720'
            },
        ]
    },

    
]

export default SARCData;